
import { Vue, Component } from 'vue-property-decorator'
import payList from '@/config/payList'
import { PayListItem } from '@/models'

@Component({})
export default class PayCard extends Vue {
  private payList: PayListItem[] = payList
}
